import {useCallback, useEffect, useRef, useState} from 'react';
import {getApiInstance} from '../services/api';
async function exportRequest(id: number, send: boolean) {
  const url = `/api/v1/mobile/integrations/strava/workouts/${id}/export`;
  const response = send ? await getApiInstance().post(url) : await getApiInstance().get(url);
  return response.data.data;
}

type ExportState = {status: string; can_send?: boolean; activity_id?: string; error_code?: string};
export function useStravaExport(workoutId: number) {
  const [state, setState] = useState<ExportState | null>(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const generation = useRef(0);
  const rounds = useRef(0);
  const inFlight = useRef(false);
  const load = useCallback(async (send = false) => {
    if (inFlight.current) return;
    inFlight.current = true;
    const current = generation.current;
    setBusy(true); setError(false);
    try {
      const data = await exportRequest(workoutId, send);
      if (generation.current === current) setState(data);
    } catch (e: any) {
      if (generation.current === current && e?.response?.status !== 403) setError(true);
    } finally {
      if (generation.current === current) {setBusy(false); inFlight.current = false;}
    }
  }, [workoutId]);
  useEffect(() => {
    generation.current++; inFlight.current = false; rounds.current = 0; setState(null);
    void load();
    return () => {generation.current++;};
  }, [load]);
  useEffect(() => {
    if (busy || error || !state || state.error_code === 'reconnect' || !['pending', 'sending', 'processing'].includes(state.status) || rounds.current >= 60) return;
    const timer = setTimeout(() => {rounds.current++; void load();}, 5000);
    return () => clearTimeout(timer);
  }, [state, busy, error, load]);
  return {state, busy, error, load};
}
